import { useQuery } from "@tanstack/react-query";
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { selector } from "src/react-query/select";
import { is } from "src/util/is";

export const useRefundDetails = ({ teamId, paymentId, enabled = true }) => {
  return useQuery(
    queryKeys.refundDetails(teamId, paymentId),
    fetchWithError,
    {
      enabled: !is.empty(teamId) && !is.empty(paymentId) && enabled,
      select: (data) => {
        const selectedData = selector(data);
        return {
          ...selectedData,
          message: data?.message,
        };
      },
    }
  );
};
